import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBell,
  faBellSlash,
  faWallet,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { getData, editStatusData } from "../../../utils/api";
import "./AdminNotifications.css";

const WITHDRAW_NAME = "Withdraw Request";
const WITHDRAW_PATH = "/wallet/withdraw-request";

const formatTime = (value) => {
  const date = new Date(value);
  if (isNaN(date)) return "";
  const diff = Math.floor((Date.now() - date.getTime()) / 1000);
  if (diff < 60) return "Just now";
  if (diff < 3600) return `${Math.floor(diff / 60)} min ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} hr ago`;
  return date.toLocaleString();
};

const AdminNotifications = ({ compact = false }) => {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  const GetNotifications = async () => {
    const response = await getData(`/admin/notifications/latest?limit=10`);
    if (response?.success) {
      setItems(response?.data?.data || []);
      setTotal(response?.data?.total || 0);
    }
  };

  useEffect(() => {
    GetNotifications();
    const timer = setInterval(GetNotifications, 60000);
    return () => clearInterval(timer);
  }, []);

  // Toggling status to inactive removes it from the dashboard list
  const Dismiss = async (id) => {
    const response = await editStatusData(`/admin/notifications/${id}`);
    if (response?.success) GetNotifications();
  };

  return (
    <div className={`admin-notif${compact ? " an-compact" : ""}`}>
      <div className="an-card">
        <div className="an-header">
          <h6 className="an-title">
            <span className="an-title-icon">
              <FontAwesomeIcon icon={faBell} />
            </span>
            Notifications
            {total > 0 && <span className="an-count">{total}</span>}
          </h6>
          {items.some((n) => n.name === WITHDRAW_NAME) && (
            <Link to={WITHDRAW_PATH} className="an-view-all">
              View withdraw requests
            </Link>
          )}
        </div>

        {items.length === 0 ? (
          <div className="an-empty">
            <FontAwesomeIcon icon={faBellSlash} />
            No new notifications
          </div>
        ) : (
          <ul className="an-list">
            {items.map((n) => {
              const isWithdraw = n.name === WITHDRAW_NAME;
              return (
                <li
                  key={n.id}
                  className={`an-item ${isWithdraw ? "is-withdraw" : ""}`}
                >
                  <div className="an-icon">
                    <FontAwesomeIcon icon={isWithdraw ? faWallet : faBell} />
                  </div>
                  <div className="an-body">
                    <div className="an-name">
                      {n.name}
                      {isWithdraw && <span className="an-tag">Action needed</span>}
                    </div>
                    {isWithdraw ? (
                      <Link to={WITHDRAW_PATH} className="an-message">
                        {n.message}
                      </Link>
                    ) : (
                      <span className="an-message">{n.message}</span>
                    )}
                    <span className="an-time">{formatTime(n.createdAt)}</span>
                  </div>
                  <button
                    className="an-dismiss"
                    onClick={() => Dismiss(n.id)}
                    title="Dismiss"
                  >
                    <FontAwesomeIcon icon={faXmark} />
                  </button>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
};

export default AdminNotifications;
